import { render, staticRenderFns } from "./orderQueryDialog.vue?vue&type=template&id=6cf46f9b&scoped=true&"
import script from "./orderQueryDialog.vue?vue&type=script&lang=js&"
export * from "./orderQueryDialog.vue?vue&type=script&lang=js&"
import style0 from "./orderQueryDialog.vue?vue&type=style&index=0&id=6cf46f9b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cf46f9b",
  null
  
)

export default component.exports